<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="row">
      <div class="col col-md-4 col-lg-4 hidden-sm-down opacity-20">
        <img src="/img/450.png" class="w-100" aria-roledescription="logo" alt="" />
      </div>

      <div class="col-sm-12 col-md-8 col-lg-8 col-xl-7 ml-auto">
        <div class="p-4 rounded-0 bg-faded logowanie">
          <router-link class="pointer label text-uppercase" :to="{ name: 'login' }">
            [ Powrót do logowania ]
          </router-link>

          <h1 class="text-left fw-700 mb-4 mt-4 d-xs-block">
            Rejestracja
          </h1>

          <form>
            <w-input class="form-group" :model="$schema.email" />

            <div class="row">
              <w-input class="form-group col-md-6" :model="$schema.firstName" />

              <w-input class="form-group col-md-6" :model="$schema.lastName" />
            </div>

            <w-checkbox class="mb-0" :model="$schema.gdprAccepted" />

            <a href="#" class="gdpr-link" @click.prevent="openGDPRModal">Polityka prywatności</a>

            <div class="row no-gutters">
              <div class="col-lg-12 pl-lg-1 my-2 text-right">
                <button class="btn btn-primary btn-lg rounded-pill" @click.prevent="submit">
                  Zarejestruj się
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <gdpr-modal :show="showGDPRModal" @close="closeGDPRModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import GdprModal from '@/components/modals/GDPRModal';
import { Errors } from '@/enums/errors.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import { authResource } from '@/resources/auth.resource';
import schema from '@/schemas/profile.schema';

// @vuese
// Rejestracja
// @group StartRoute
export default {
  components: { GdprModal },
  mixins: [formMixin, notificationsMixin],
  external: {},
  data() {
    return {
      list: [],
      model: {
        email: '',
        firstName: '',
        lastName: ''
      },
      success: false,
      showGDPRModal: false
    };
  },
  computed: mapState({ appTitle: state => state.system.appTitle }),
  schema,
  mounted() {
    document.title = 'Zarejestruj się' + ' - ' + this.appTitle;
  },
  methods: {
    // @vuese
    // Rejestruje użytkownika
    submit() {
      if (!this.$schema.$validateAll().length) {
        authResource
          .register(this.model)
          .then(() =>
            this.$store.dispatch('setConfirm', {
              title: 'Konto zostało zarejestrowane',
              description: 'Kliknij w link wysłany na twój adres e-mail, aby potwierdzić konto.',
              showCloseButton: false,
              submitButton: 'Ok',
              onSuccess: () => this.$router.push({ name: 'login' })
            })
          )
          .catch(err => this.notifyError(err.message || Errors.ERROR_TRY_AGAIN_LATER));
      }
    },
    // @vuese
    // Otwiera modal z polityką prywatności
    openGDPRModal() {
      this.showGDPRModal = true;
    },
    // @vuese
    // Zamyka modal z polityką prywatności
    closeGDPRModal() {
      this.showGDPRModal = false;
    }
  }
};
</script>

<style scoped>
.btn.btn-danger {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 1.2rem;
}

.custom-control.custom-checkbox.mb-0 {
  margin-bottom: 0 !important;
}

.gdpr-link {
  margin-left: 1.625rem;
}

.label {
  font-size: 1rem;
  font-weight: 600;
}
</style>
